/*
  Keeps each upsell row's variant dropdown and its hidden `id` input in sync.

  That is the whole job. Adding to the cart, the drawer, the header count and
  the mini-cart re-render all belong to Concept's own `ProductForm`
  (assets/theme.js:5972), which is attached to the row via `is="product-form"`
  in snippets/pf-upsell-row.liquid. Nothing here touches fetch, pubsub or the
  drawer, so this file cannot drift from the theme's own buy buttons.

  Why not reuse assets/pf-card-variants.js: that one resolves a variant from
  RADIO inputs inside a `.product-card` (pf-card-variants.js:111-114, 122).
  A `<select>` never triggers it and these rows are not cards, so the two would
  have had to be generalised into something that served neither well.

  Delegated from `document`, so rows that arrive later — the product section
  re-renders on every variant change — are handled without re-initialising.
*/
(() => {
  'use strict';

  const sync = (row) => {
    const select = row.querySelector('[data-pf-upsell-select]');
    const input = row.querySelector('[data-pf-upsell-input]');
    if (!select || !input) return;

    const option = select.selectedOptions[0];
    if (!option) return;

    input.value = select.value;

    // A sold-out variant must not be submittable. `disabled` on the button is
    // enough: ProductForm reads the input on submit, and never fires.
    const button = row.querySelector('[data-pf-upsell-add]');
    if (button) button.disabled = !!option.disabled;

    // Price is rendered per variant rather than through `product-price`, so the
    // update is a single text node and cannot mangle sale markup.
    const price = row.querySelector('[data-pf-upsell-price-now]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-pf-upsell-select]');
    if (!select) return;
    const row = select.closest('[data-pf-upsell-row]');
    if (row) sync(row);
  });

  // Initial pass: a variant can be preselected sold-out, and a browser may
  // restore a previous selection on back-navigation without firing `change`.
  const init = () => document.querySelectorAll('[data-pf-upsell-row]').forEach(sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
